// src/store/modules/result.js

// import axios from "@/axios";
// import endpoints from "@/endpoints.js";
const state = {
    result: {},
};

const mutations = {
    setResult(state, resultData) {
        state.result = resultData;
    },
};

const actions = {};

const getters = {
    result: (state) => state.result,
};

export default {
    state,
    mutations,
    actions,
    getters,
};
